import React from "react";
import { Col, Row } from "react-bootstrap";

function Toolstack() {
  const tools = [
    { name: "macOS", url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apple/apple-original.svg" },
    { name: "VS Code", url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg" },
    { name: "DataGrip", url: "https://raw.githubusercontent.com/simple-icons/simple-icons/develop/icons/datagrip.svg" },
    { name: "DBeaver", url: "https://raw.githubusercontent.com/simple-icons/simple-icons/develop/icons/dbeaver.svg" },
    { name: "Postman", url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postman/postman-original.svg" },
    { name: "Terraform", url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/terraform/terraform-original.svg" },
    { name: "Git", url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg" },
    { name: "Docker", url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg" },
  ];

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {tools.map((tool, idx) => (
        <Col key={idx} xs={4} md={2} className="tech-icons">
          <img
            src={tool.url}
            alt={tool.name}
            title={tool.name}
            className="tech-icon-images"
            style={{ width: "60px", height: "60px" }}
          />
          <div className="tech-icons-text">{tool.name}</div>
        </Col>
      ))}
    </Row>
  );
}

export default Toolstack;
